import React, { useState, useEffect } from 'react';
import { sound } from './SoundSystem';

export default function CvModal({ isOpen, onClose }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [zoomLevel, setZoomLevel] = useState(1);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleDownload = () => {
    sound.playSuccess();
    if (window.confetti) {
      window.confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 },
        colors: ['#00F59B', '#00E5FF', '#8B5CF6']
      });
    }
  };

  const handlePrint = () => {
    sound.playClick();
    window.open('/CV-BABACAR-DIAGNE-2026.pdf', '_blank');
  };

  return (
    <div className="cyber-modal-overlay" onClick={onClose}>
      <div className="cyber-modal-container cv-modal-container" onClick={(e) => e.stopPropagation()}>
        {/* Modal Header */}
        <div className="cyber-modal-header">
          <div className="modal-title-group">
            <span className="terminal-badge">CV_EXÉCUTIF.PDF</span>
            <h3>Curriculum Vitae — Babacar Diagne</h3>
            <span className="cv-spec-tag">Ingénieur Logiciel Full Stack • 2026 Edition</span>
          </div>

          <div className="modal-header-actions">
            {/* Page Switcher */}
            <div className="page-switcher-group">
              <button 
                className={`page-pill-btn ${currentPage === 1 ? 'active' : ''}`}
                onClick={() => {
                  sound.playClick();
                  setCurrentPage(1);
                }}
              >
                Page 1 (Expériences)
              </button>
              <button 
                className={`page-pill-btn ${currentPage === 2 ? 'active' : ''}`}
                onClick={() => {
                  sound.playClick();
                  setCurrentPage(2);
                }}
              >
                Page 2 (Formations)
              </button>
            </div>

            {/* Zoom Controls */}
            <div className="zoom-controls">
              <button 
                className="zoom-btn"
                onClick={() => setZoomLevel((z) => Math.max(0.7, z - 0.15))}
                title="Dézoomer"
              >
                <i className="fa-solid fa-magnifying-glass-minus"></i>
              </button>
              <span className="zoom-text">{Math.round(zoomLevel * 100)}%</span>
              <button 
                className="zoom-btn"
                onClick={() => setZoomLevel((z) => Math.min(1.6, z + 0.15))}
                title="Zoomer"
              >
                <i className="fa-solid fa-magnifying-glass-plus"></i>
              </button>
            </div>

            {/* Download CTA */}
            <a 
              href="/CV-BABACAR-DIAGNE-2026.pdf" 
              download="CV-BABACAR-DIAGNE-2026.pdf"
              className="cyber-cta-btn primary"
              onClick={handleDownload}
            >
              <i className="fa-solid fa-cloud-arrow-down"></i>
              <span>Télécharger PDF HD</span>
            </a>

            <button className="cyber-cta-btn secondary" onClick={handlePrint} title="Ouvrir dans un nouvel onglet">
              <i className="fa-solid fa-arrow-up-right-from-square"></i>
            </button>

            <button className="cyber-modal-close" onClick={onClose} title="Fermer">
              <i className="fa-solid fa-xmark"></i>
            </button>
          </div>
        </div>

        {/* Modal Body / Viewer */}
        <div className="cv-modal-body">
          <div className="cv-paper-shadow-wrapper" style={{ transform: `scale(${zoomLevel})` }}>
            <div className="cv-paper-sheet">
              <img 
                src={`/assets/cv-page-${currentPage}.png`} 
                alt={`CV Babacar Diagne Page ${currentPage}`}
                className="cv-render-img"
              />
            </div>
          </div>
        </div>

        {/* Modal Footer */}
        <div className="cv-modal-footer">
          <div className="cv-footer-left">
            <span className="doc-meta">
              <i className="fa-solid fa-file-pdf"></i> Format A4 Universel • Conforme ATS • Résolution 300 DPI
            </span>
          </div>
          <div className="cv-footer-right">
            <span className="status-online-dot"></span>
            <span>Document Certifié Babacar Diagne • Saint-Louis, Sénégal</span>
          </div>
        </div>
      </div>
    </div>
  );
}
